import { render } from "./SourceCostGenerator.vue?vue&type=template&id=383c050c&scoped=true"
import script from "./SourceCostGenerator.vue?vue&type=script&lang=js"
export * from "./SourceCostGenerator.vue?vue&type=script&lang=js"

import "./SourceCostGenerator.vue?vue&type=style&index=0&id=383c050c&scoped=true&lang=css"
import "./SourceCostGenerator.vue?vue&type=style&index=1&id=383c050c&lang=css"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383c050c"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
